"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.shouldPolyfill = void 0;
function supportedLocalesOf(locale) {
    if (!locale) {
        return true;
    }
    var locales = Array.isArray(locale) ? locale : [locale];
    return (Intl.RelativeTimeFormat.supportedLocalesOf(locales).length ===
        locales.length);
}
function shouldPolyfill(locale) {
    return !('RelativeTimeFormat' in Intl) || !supportedLocalesOf(locale);
}
exports.shouldPolyfill = shouldPolyfill;
